import React, {useState} from "react";
import { Modal, Button } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinner} from "@fortawesome/free-solid-svg-icons";

const ConfirmationDialog = (props) => {
  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      size="xs"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {props.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.dialogApiError}
        {props.body}
      </Modal.Body>
      <Modal.Footer>
        <Button
          className={`btn btn-${props.cancelButtonVariant}`}
          onClick={props.onHide}
        >
          {props.cancelButtonText ? props.cancelButtonText : props.t("DialogCancel")}
        </Button>
        <Button
          className={`btn btn-${props.confirmButtonVariant}`}
          onClick={() => props.onSubmit()}>
          {props.confirmButtonText ? props.confirmButtonText : props.t("DialogConfirm")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default withTranslation()(ConfirmationDialog);
